import React from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const BiLabInfoHome = () => {
  return (
    <Page flex="grow" background="transparent">
      <Box margin={{ top: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader 
            pad={{ top: '5px', bottom: '40px' }} 
            title={
              <Text size="xxlarge" weight="bold" color="text-strong">
                BI Lab—who we are
              </Text>
            } 
            subtitle={
              <Text size="large" color="text">
                Powering Future State HPE
              </Text>
            }
            size='medium'
          />
        </Box>      
      </Box> 

      <PageContent flex="grow">
        <Box
          pad="xlarge"
          align="center"
          justify="center"
          round="large"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <Heading 
            size="small" 
            weight="bold" 
            margin={{ top: 'none' }} 
            color="text-strong"
          >
            Coming soon...
          </Heading>
          <Text color="text" textAlign="center">
            Our mission, our team, and our commitment to driving data-first transformation.
          </Text>
        </Box>
      </PageContent>  
    </Page>
  );
};